export default function PHP_strnatcasecmp() {
  return (
    <div>
      <h1>PHP_strnatcasecmp</h1>
    </div>
  );
}
